import { render, staticRenderFns } from "./DocumentationRecordAPI.vue?vue&type=template&id=5bf38bdf"
import script from "./DocumentationRecordAPI.vue?vue&type=script&lang=js"
export * from "./DocumentationRecordAPI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports